/**
 * ElevenLabs ConvAI Widget Component
 *
 * Dynamically loads the ElevenLabs ConvAI widget using the agent ID from environment variables.
 * This prevents the agent ID from being hardcoded in the HTML and makes it configurable via Cloudflare secrets.
 */

import { useEffect } from 'react';

export function ElevenLabsWidget() {
  useEffect(() => {
    const agentId = import.meta.env.VITE_ELEVENLABS_AGENT_ID;

    // Only load widget if agent ID is configured
    if (!agentId) {
      console.warn('[ElevenLabs] Agent ID not configured. Widget will not load.');
      return;
    }

    // Create the widget element
    const widget = document.createElement('elevenlabs-convai');
    widget.setAttribute('agent-id', agentId);

    // Append to body
    document.body.appendChild(widget);

    // Load the ElevenLabs widget script
    const script = document.createElement('script');
    script.src = 'https://unpkg.com/@elevenlabs/convai-widget-embed';
    script.async = true;
    script.type = 'text/javascript';

    document.body.appendChild(script);

    console.log('[ElevenLabs] Widget loaded with agent ID:', agentId);

    // Cleanup function
    return () => {
      // Remove widget element
      const widgetElement = document.querySelector('elevenlabs-convai');
      if (widgetElement) {
        widgetElement.remove();
      }

      // Remove script element
      const scriptElement = document.querySelector('script[src="https://unpkg.com/@elevenlabs/convai-widget-embed"]');
      if (scriptElement) {
        scriptElement.remove();
      }
    };
  }, []);

  return null; // This component doesn't render anything
}
